<template>
<m-pageframe
    title="TCR Events"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
      
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

         <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickTechnicalDetails(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],
            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Type', value: 'event_type'},
                { text: 'Brand Id', value: 'brand_id'},
                { text: 'Brand Name', value: 'brand_name'},
                { text: 'Campaign Id', value: 'campaign_id'},
                { text: 'Description', value: 'description'},
                { text: 'Action', value: 'action'},
            ],
        }
    },
    
    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/tcr/events',
            
                'params' : {
                        'full_text': this.full_text,
                        'sort': 'time:desc',
                        'event_type': { 'type': '!=', value: 'campaign-billed'}
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list events',
            });
        },

        onClickTechnicalDetails(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Campaign Technical Details',
                    'object': item,
                });
        },
        
    },

   
}
</script>

<style lang="scss" scoped>
</style>